<template>
    <div ref="mathContainer"></div>
  </template>
  
  <script>
  import katex from "katex";
  import "katex/dist/katex.min.css";
  
  export default {
    name: "KaTeXComponent",
    props: {
      expression: {
        type: String,
        required: true,
      },
    },
    computed: {
      processedExpression() {
        // Replace space characters with "~" for LaTeX non-breaking spaces
        return this.expression ? this.expression.replace(/ /g, "~") : "";
      },
    },
    mounted() {
      this.renderMath();
    },
    watch: {
      processedExpression: {
        immediate: true,
        handler() {
          this.renderMath();
        },
      },
    },
    methods: {
      renderMath() {
        const container = this.$refs.mathContainer;
        if (!container) return;
  
        try {
          katex.render(this.processedExpression, container, {
            throwOnError: false,
          });
        } catch (error) {
          console.error("KaTeX rendering error:", error);
          container.innerHTML = `<span style="color: red;">Invalid expression</span>`;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  :deep(.katex) {
      padding: 4px 0;
      display: inline-block;
  }
  </style>
  